export const SESSION_ID = 'session';
export const GLOBAL_ID = 'global';

export const SESSION_LABEL = 'Session Functions';
export const GLOBAL_LABEL = 'Global Functions';

const functionsDescription = {
  session: {
    id: SESSION_ID,
    label: SESSION_LABEL,
    editable: true,
  },
  global: {
    id: GLOBAL_ID,
    label: GLOBAL_LABEL,
    editable: false,
  },
};

export default functionsDescription;
